import { render, staticRenderFns } from "./NewDataExportButton.vue?vue&type=template&id=c5f1cc1a&scoped=true"
import script from "./NewDataExportButton.vue?vue&type=script&lang=js"
export * from "./NewDataExportButton.vue?vue&type=script&lang=js"
import style0 from "./NewDataExportButton.vue?vue&type=style&index=0&id=c5f1cc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f1cc1a",
  null
  
)

export default component.exports